export default __webpack_public_path__ + "static/media/chrome.5f0bb5b9.png";